(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('menuService', menuService);

    menuService.$inject = ['$http', 'CONFIG', 'messageService'];

    function menuService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/menus';
        var service = {
            getMenus: getMenus,
            getMenusUser: getMenusUser,
            getMenusClient: getMenusClient
        }

        return service;

        function getMenus(){
            return $http.get(urlBase + "/tree")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getMenusUser(){
            return $http.get(urlBase + "/byLogin" )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getMenusClient(client){
            return $http.get(urlBase + "/byClient?clientId="+client)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }
    }
})();
